import React, { useContext, useEffect, useState } from 'react'
import filterIcon from '../../assets/icons/filters.svg';
import { t } from 'i18next';
import { Input, Spinner } from 'reactstrap';
import { EntryAndDepartureFilterModal } from './EntryAndDepartureFilterModal';
import ButtonGroupGrayCustom from '../Buttons/ButtonGroupGrayCustom';
import ResourceTypeContext from '../../context/ResourceTypeContext/ResourceTypeContext';
import useWindowSize from '../../customHooks/useWindowSize';
import download from '../../assets/icons/download-icon.svg'
import EntryAndDepartureReportContext from '../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext';
import { havePermission, isoToDate, replaceExpecialCharacters } from '../../helpers/helpers';
import './entryAndDeparture.css';
import CustomSelectDate from '../CustomSelectDate/CustomSelectDate';
import { CustomPopoverWhite } from '../CustomPopover/CustomPopoverWhite';

const EntryAndDepartureFilterHeader = ({ systemDate }) => {

    const { windowWidth } = useWindowSize();

    const inputDateColor = windowWidth >= 576 ? 'bg-transparent border-0' : '';
    const putCardMobile = windowWidth <= 650;

    const [showModal, setShowModal] = useState(false);
    const [showDateModal, setShowDateModal] = useState(false);

    const [searchText, setSearchText] = useState('');

    const { getResourceTypes, resourceState } = useContext(ResourceTypeContext);
    const { resourcesTypes } = resourceState;

    const { entryAndDepartureReportState, getEntriesAndDepartures, downloadEntriesAndDeparturesReport } = useContext(EntryAndDepartureReportContext);
    const { filters, isFetching, entriesAndDeparturesPaginated, isDownloadingReport, totalPages, exportTypes } = entryAndDepartureReportState;

    const noResults = entriesAndDeparturesPaginated.length === 0;

    const needToFilterMore = totalPages > process.env.REACT_APP_MAX_PAGES_DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT;

    const resourcesTypesOptions = resourcesTypes.map(resourcesType => ({
        title: resourcesType.description,
        active: filters.resource_type.includes(resourcesType.code),
        onClick: () => handleSetResourceType(resourcesType.code)
    }));

    const exportOptions = exportTypes.map(exportType => ({
        name: exportType.name,
        onClick: () => downloadEntriesAndDeparturesReport(exportType.code)
    }));


    const handleSetResourceType = (newResourcesType) => {
        const wasAdded = filters.resource_type.some(resourcesTypeSelected => resourcesTypeSelected === newResourcesType);
        if (wasAdded) {
            getEntriesAndDepartures({ ...filters, resource_type: filters.resource_type.filter(resourcesTypeSelected => resourcesTypeSelected !== newResourcesType), reg_from: 1, search_text: '', })
        } else {
            getEntriesAndDepartures({ ...filters, resource_type: [...filters.resource_type, newResourcesType], reg_from: 1, search_text: '', })
        }
    };

    const handleOnKeyPress = (e) => {
        if ((e.key === 'Enter')) {
            getEntriesAndDepartures({
                ...filters,
                search_text: searchText,
                reg_from: 1
            })
        };
    };

    const handleChangeInPlant = (value) => {
        if (value === true) {
            getEntriesAndDepartures({
                ...filters,
                'in_plant': value,
                'date_from': `${systemDate.split(' ')[0]}`,
                'date_to': `${systemDate.split(' ')[0]}`,
                search_text: '',
                reg_from: 1
            })
        } else {
            getEntriesAndDepartures({
                ...filters,
                'in_plant': value,
                search_text: '',
                reg_from: 1
            })
        }
    }

    const handleSetDatesInFilter = (date_from, date_to) => {
        getEntriesAndDepartures({
            ...filters,
            date_from,
            date_to,
            search_text: '',
            reg_from: 1
        })
    }

    const showDateInInput = () => {
        let { date_from, date_to } = filters;

        if (date_from === date_to && date_to === systemDate.split(' ')[0]) {
            return t('TODAY')
        }

        return putCardMobile ? `${isoToDate(date_from.replaceAll('-', ''))} - ${isoToDate(date_to.replaceAll('-', ''))}` : `${isoToDate(date_from.replaceAll('-', ''))}\n${isoToDate(date_to.replaceAll('-', ''))}`;
    }

    useEffect(() => {
        setSearchText(filters.search_text)
    }, [filters.search_text])

    useEffect(() => {
        getResourceTypes();
        // eslint-disable-next-line
    }, [])

    return (
        <>

            {showModal && (
                <EntryAndDepartureFilterModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                />
            )}

            {showDateModal && (
                <CustomSelectDate
                    showModal={showDateModal}
                    setShowModal={setShowDateModal}
                    dateToInitialState={filters.date_to}
                    dateFromInitialState={filters.date_from}
                    onSubmit={handleSetDatesInFilter}
                    validateDates
                />
            )}

            <div className="row row-cols-1 row-cols-sm-4 align-items-center gap-3 gap-sm-0">

                <div className="col col-sm-3">
                    <div className='position-relative'>
                        <input
                            placeholder={t('SEARCH')}
                            type={"text"}
                            name={'search_text'}
                            className="form-control access-input"
                            autoComplete='off'
                            onChange={(e) => setSearchText(replaceExpecialCharacters(e.target.value))}
                            onKeyPress={handleOnKeyPress}
                            value={searchText}
                        />

                        <span
                            style={{ top: '15%', right: '10px', position: 'absolute' }}
                            type='button'
                            onClick={() => setShowModal(!showModal)}
                        >
                            <img src={filterIcon} alt="filters" />
                        </span>
                    </div>
                </div>

                <div className="col col-sm-3">
                    <div className='position-relative'>
                        <input
                            id='dateInReport'
                            value={showDateInInput()}
                            type={"button"}
                            name={'dateEntryAndDeparture'}
                            className={`form-control datepicker-input text-start ${inputDateColor}`}
                            onClick={() => setShowDateModal(!showDateModal)}
                        />
                        <div
                            type='button'
                            className='position-absolute d-sm-none d-block'
                            style={{ top: '19%', right: '10px' }}
                            onClick={() => setShowDateModal(!showDateModal)}
                        >
                            <span className='new-orange-color'>{t('CHANGE')}</span>
                        </div>
                    </div>
                </div>

                <div className="col col-sm-2">
                    <Input
                        type="checkbox"
                        checked={filters.in_plant}
                        disabled={!havePermission(8)}
                        onChange={() => handleChangeInPlant(!filters.in_plant)}
                    />
                    <span className='ms-1 titlelabel-filter'>{t('PLANT_RESOURCES')}</span>
                </div>

                <div className='col col-sm-3'>
                    {
                        isFetching ?
                            <Spinner />
                            :
                            <>
                                <div className='d-flex align-items-center'>
                                    <span className='me-1 pb-1 titlelabel-filter'>{t('RESS')}</span>
                                    <ButtonGroupGrayCustom options={resourcesTypesOptions} />
                                </div>

                            </>
                    }
                </div>

                <div className="col col-sm-1 text-center ps-0 d-sm-block d-none">
                    {havePermission(7) && (
                        <CustomPopoverWhite
                            idPopover={'export-entry-departure'}
                            withTooltip
                            placementTooltip={'top'}
                            className='btn-outline-black'
                            popoverPlacement={'bottom'}
                            textTooltip={needToFilterMore ? t('FILTER_MORE_FOR_DOWNLOAD') : t('DOWNLOAD')}
                            disabled={noResults || isDownloadingReport || needToFilterMore}
                            buttonIcon={
                                isDownloadingReport ?
                                    <Spinner />
                                    :
                                    <img src={download} alt="" />
                            }
                            options={exportOptions}
                        />
                    )}
                </div>

            </div>
        </>
    )
}

export default EntryAndDepartureFilterHeader